import queryString from "query-string";
import { appBaseUrl } from "utils/config";
import { getService, postService, putService } from "services/commonServices";

export class OldEmailServices {
  apiForOldEmailPagination(payload, param) {
    const query = queryString.stringify(param);
    // let url = `${appBaseUrl}/oldEmailServer/searchEmailSection?${query}`
    let url = `https://cqnoval.ictc.com.np/api/app/oldEmailServer/searchEmailSection?${query}`;
    const response = postService(url, payload);
    return response;
  }

  apiForGetEmailDetail(id, payload) {
    // let url = `${appBaseUrl}/app/oldEmailServer/getEmailDetailWithContent/${id}`
    const query = queryString.stringify(payload);
    let url = `https://cqnoval.ictc.com.np/api/app/oldEmailServer/getEmailDetailWithContent/${id}?${query}`;
    const response = postService(url);
    return response;
  }
}
